import {INPUT_TYPES} from "../constants/inputs";

export default class Sequence {
    static preload(scene){
        scene.load.image('arrow', 'src/assets/img/arrow.png');
    }

    constructor({scene}){
        this.scene = scene;
        this.container = this.scene.rexUI.add.sizer({
            orientation: "x",
            anchor: "center",
            x: this.scene.game.config.width / 2,
            y: this.scene.game.config.height / 2
        });
    }

    addSequence(sequence){
        this.container.removeAll(true);
        this.container.scale = 1;
        this.currentArrow = 0;
        sequence.forEach(inputType => {
            const arrow = this.scene.add.image(0, 0, "arrow");

            if(inputType === INPUT_TYPES.DOWN) arrow.rotation = Math.PI / 2;
            if(inputType === INPUT_TYPES.LEFT) arrow.rotation = Math.PI;
            if(inputType === INPUT_TYPES.UP) arrow.rotation = -Math.PI / 2;

            arrow.filter = {
                grayscale: this.scene.plugins.get('rexGrayScalePipeline').add(arrow, { intensity: 0 })
            };
            arrow.setScale(0.25);
            this.container.add(arrow);
        })
        this.container.layout();
        this.container.scale = 0;
        this.scene.tweens.add({
            targets: [this.container],
            scale: 1,
            duration: 100,
            ease: Phaser.Math.Easing.Bounce.Out
        })
    }

    arrowHit(){
        this.container.children[this.currentArrow].filter.grayscale.intensity = 1;
        this.currentArrow++;
    }

    reset(){
        this.container.children.forEach(c => c.filter.grayscale.intensity = 0);
        this.currentArrow = 0;
    }

    destroy(){
        this.scene.tweens.add({
            targets: [this.container],
            scale: 0,
            duration: 100,
            ease: Phaser.Math.Easing.Bounce.In
        }).on("complete", () => {
            this.container.removeAll(true);
        })
    }
}